/* Piegādes datumi groza rindām (Delivery Estimator). Produkta lapā app datumus pieliek pats, bet precēm,
   kas grozā nonāk citādi (papildpreces, "pērc kopā", komplekti), to dara šis fails pēc tiem pašiem noteikumiem. */
(function () {
  const blank = (x) => {
    const t = Object.prototype.toString.call(x);
    if (t === '[object Undefined]' || t === '[object Null]') return true;
    if (t === '[object String]') return x.trim() === '';
    if (t === '[object Object]') return !Object.keys(x).length;
    if (t === '[object Array]') return !x.length;
    if (t === '[object Boolean]') return x === false;
    return false;
  };
  const etaEarly = window.estimatorConfig || null;
  const etaCfg = () => {
    const app = window['Estimator-App'];
    const c = app && app.getSettings ? app.getSettings() : null;
    return c && c.rules ? c : window.estimatorConfig || etaEarly;
  };
  const etaText = (cfg, key, langs) => {
    const pick = (o) => key.split('.').reduce((a, k) => (a && k in a ? a[k] : undefined), o);
    const lim = (cfg.permissions || {}).languages;
    const n = lim === '∞' ? 99999999 : parseInt(lim);
    const loc = String(cfg.locale || '').toLowerCase().split(/[-_]/)[0];
    const own = n > 0 && Object.keys(langs).filter((k) => k !== 'default').slice(0, n).includes(loc) ? pick(langs[loc]) : undefined;
    if (!blank(own)) return own;
    const def = pick(langs.default || {});
    return blank(def) ? '' : def;
  };
  const etaDates = (conf, rule) => {
    const biz = conf.businessSettings, adv = conf.advancedSettings;
    const hol = biz.holidays, cut = biz.cutoffTimes;
    const tz = blank(biz.timezone) || biz.timezone === 'default' ? Intl.DateTimeFormat().resolvedOptions().timeZone : biz.timezone;
    const dl = adv.dates && !blank(adv.dates.locale) ? adv.dates.locale : 'en-US';
    const nowIn = (d = null, { locale = 'en-US', hour12 = false, timeZone = null } = {}) => {
      const o = { hour12 };
      if (!blank(timeZone)) o.timeZone = timeZone;
      return new Date((blank(d) ? new Date() : new Date(d)).toLocaleString(locale, o));
    };
    const fmt = (d, f = 'Y-m-d', opt = {}) => {
      if (!(Object.prototype.toString.call(d) === '[object Date]' && !isNaN(d.getTime()))) return null;
      const locale = opt.locale || dl;
      const day = d.getDate(), wd = d.getDay(), y = d.getFullYear(), h = d.getHours(), mi = d.getMinutes(), mo = d.getMonth() + 1, s = d.getSeconds();
      const suf = ['st', 'nd', 'rd'];
      const S = suf[(day % 10) - 1] == null || [11, 12, 13].includes(day % 100) ? 'th' : suf[(day % 10) - 1];
      let dd = day, mm = mo;
      if (opt.isRemoveLeadingZero !== true) { dd = String(day).padStart(2, '0'); mm = String(mo).padStart(2, '0'); }
      const doy = Math.floor((d - new Date(y, 0, 1)) / 86400000);
      const g = (h + 24) % 12 || 12;
      const two = (x) => (String(x).length < 2 ? '0' : '') + x;
      const off = d.getTimezoneOffset();
      let zone = (off > 0 ? '-' : '+') + String(Math.floor(Math.abs(off) / 60)).padStart(2, '0') + ':' + String(Math.abs(off) % 60).padStart(2, '0');
      if (!blank(opt.timezone)) {
        const part = new Intl.DateTimeFormat(locale, { timeZone: opt.timezone, hour12: false, hour: '2-digit', minute: '2-digit', timeZoneName: 'shortOffset' }).formatToParts();
        const m = ((part.find((p) => p.type === 'timeZoneName') || {}).value || 'UTC').match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
        zone = m ? m[1] + String(m[2]).padStart(2, '0') + ':' + String(m[3] || '00').padStart(2, '0') : 'Z';
      }
      const map = {
        d: dd, D: d.toLocaleDateString(locale, { weekday: 'short' }), j: day, l: d.toLocaleDateString(locale, { weekday: 'long' }), N: wd, S,
        z: Math.floor((d - new Date(y, 0, 0)) / 7200000), W: Math.ceil((wd + 1 + doy) / 7),
        F: d.toLocaleDateString(locale, { month: 'long' }), m: mm, M: d.toLocaleDateString(locale, { month: 'short' }), n: mo,
        t: new Date(y, mo - 1, 0).getDate(), L: (y % 4 == 0 && y % 100 != 0) || y % 400 == 0 ? 1 : 0, o: y, Y: y, y: y.toString().substr(-2),
        a: h >= 12 ? 'pm' : 'am', A: h >= 12 ? 'PM' : 'AM', g, G: h, h: two(g), H: two(h), i: two(mi), s: two(s),
        c: y + '-' + mm + '-' + dd + 'T' + two(h) + ':' + two(mi) + ':' + two(s) + zone,
      };
      return f.replace(/\\?([a-zA-Z])/g, (x, c) => map[c] || c);
    };
    const work = (d, days) => days[d.getDay()];
    const isHol = (d) => hol.includes(fmt(d, 'Y-m-d'));
    const dayName = (d) => d.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
    const add = (start, n, days) => {
      const d = new Date(start);
      let k = 0;
      while (k < n) { d.setDate(d.getDate() + 1); if (work(d, days) && !isHol(d)) k++; }
      while (!work(d, days) || isHol(d)) d.setDate(d.getDate() + 1);
      const [hh, mm] = cut[dayName(d)].split(':').map(Number);
      d.setHours(hh, mm, 0, 0);
      return d;
    };
    const today = nowIn(null, { locale: 'en', timeZone: tz });
    const late = work(today, biz.workingDays.dispatch) && !isHol(today) && (() => {
      const c = cut[dayName(today)];
      if (!c) return false;
      const [hh, mm] = c.split(':').map(Number);
      const t = nowIn(today, { locale: 'en', timeZone: tz });
      t.setHours(hh, mm, 0, 0);
      return today > t;
    })() ? 1 : 0;
    const pMin = add(today, parseInt(rule.dates.dispatch.minDay) + late, biz.workingDays.dispatch);
    const pMax = add(today, parseInt(rule.dates.dispatch.maxDay) + late, biz.workingDays.dispatch);
    const dMin = add(pMax, rule.dates.delivery.minDay, biz.workingDays.delivery);
    const dMax = add(pMax, rule.dates.delivery.maxDay, biz.workingDays.delivery);
    const out = (d) => fmt(new Date(fmt(d, 'c', { timezone: tz })), adv.dates.format, { isRemoveLeadingZero: adv.dates.isRemoveZero });
    return {
      '{{preparation_min_date}}': out(pMin), '{{preparation_max_date}}': out(pMax),
      '{{delivery_min_date}}': out(dMin), '{{delivery_max_date}}': out(dMax),
    };
  };
  const etaProps = (p, v) => {
    const cfg = etaCfg();
    const conf = cfg && cfg.configuration;
    if (!conf || blank(cfg.rules)) return null;
    const gen = conf.generalSettings || {}, perm = cfg.permissions || {};
    if (gen.enable !== true || perm.cart !== true) return null;
    const tracked = v.tracked === 'shopify' && (v.policy === 'deny' || v.policy === 'continue');
    if (v.quantity <= 0 && !((!tracked && gen.isUnavailableProducts === true) || (v.policy === 'continue' && gen.isOversoldProducts === true))) return null;
    const order = (a, b) => (a.priority !== b.priority ? a.priority - b.priority : a.id - b.id);
    const unsure = [];
    const cond = (r) => (c) => {
      const eq = c.operator === '=', ne = c.operator === '!=';
      if (!blank(c.vendors)) return (eq && c.vendors.includes(p.vendor)) || (ne && !c.vendors.includes(p.vendor));
      if (!blank(c.productTypes)) return (eq && c.productTypes.includes(p.type)) || (ne && !c.productTypes.includes(p.type));
      if (!blank(c.tags)) return blank(p.tags) ? ne : c.tags.some((t) => (eq ? p.tags.includes(t) : !p.tags.includes(t)));
      if (!blank(c.productSkus)) return (eq && c.productSkus.includes(v.sku)) || (ne && !c.productSkus.includes(v.sku));
      if (!blank(c.locations)) { unsure.push(r); return false; }
      if (!blank(c.inventoryType)) {
        const q = v.quantity === undefined ? 0 : v.quantity, st = c.inventoryStock;
        return !!{ in_stock: q > 0, out_of_stock: q <= 0, custom_stock: (eq && q === st) || (ne && q !== st) || (c.operator === '>' && q > st) || (c.operator === '<' && q < st) }[c.inventoryType];
      }
      return false;
    };
    const hits = Object.values(cfg.rules).filter((r) => {
      const vis = r.visibility || {};
      if (!['all', 'collections', 'products', 'variants', 'automated'].includes(vis.type)) return false;
      const type = perm.conditions === true ? vis.type : 'all';
      if (type === 'all') return true;
      if (type === 'products') return !blank(vis.products) && vis.products.includes(p.id);
      if (type === 'variants') return !blank(vis.variants) && vis.variants.includes(v.id);
      if (type === 'collections') { if (!blank(vis.collections) && p.collections === undefined) { unsure.push(r); return false; } return !blank(vis.collections) && !blank(p.collections) && p.collections.some((id) => vis.collections.includes(id)); }
      const cs = (vis.automated && vis.automated.conditions) || [];
      const ok = cs.filter(cond(r));
      if (!ok.length) return false;
      return vis.automated.type === 'and' ? ok.length === cs.length : vis.automated.type === 'or';
    });
    hits.sort(order);
    const rule = (gen.isPriorityRule === true ? hits.slice(0, 1) : hits).filter((r) => blank(r.visibility.zipcodes))[0];
    // noliktavu nosacījumu app pārbauda savā serverī: datumu liekam tikai tad, ja šāds noteikums nevarētu uzvarēt
    if (unsure.some((r) => !rule || order(r, rule) < 0)) return null;
    if (!rule || rule.isCart !== true || !blank(rule.visibility.countries)) return null;
    const label = etaText(cfg, 'cartLabel', rule.languages), msg = etaText(cfg, 'cartMessage', rule.languages);
    if (blank(label) || blank(msg)) return null;
    const map = etaDates(conf, rule);
    const props = { [label]: msg.replace(new RegExp(Object.keys(map).join('|'), 'gi'), (m) => map[m]) };
    // _estimator apzināti neliek: app ar to rindu pārrēķina citā dienā un sūta change.js bez daudzuma (daudzums kļūst 1)
    return props;
  };

  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const produkti = {};
  const izlaist = new Set();
  let darbs = null, velreiz = false, svesi = 0, kustiba = 0, atk = 0, gaida = false;
  const MUT = /\/cart\/(add|change|update|clear)/;

  const produkts = (handle) => (produkti[handle] ||= f0(`${root}products/${handle}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null));

  // groza HTML pārzīmē bez atvēršanas (drawer vai groza lapa)
  const parzimet = async () => {
    const drawer = document.querySelector('cart-drawer');
    const items = document.querySelector('cart-items');
    const el = drawer && drawer.getSectionsToRender ? drawer : items && items.getSectionsToRender ? items : null;
    if (!el) return;
    const sec = el.getSectionsToRender();
    const note = document.getElementById('CartDrawer-Note');
    if (note && document.activeElement === note) { if (!gaida) { gaida = true; setTimeout(() => { gaida = false; parzimet(); }, 1000); } return; }
    const noteVal = note ? note.value : '';
    const bija = !!(drawer && drawer.contains(document.activeElement));
    const r = await f0(`${root}cart/update.js`, { method: 'POST', headers: JSONH, body: JSON.stringify({ sections: sec.map((s) => s.section || s.id).join(','), sections_url: location.pathname }) });
    const j = await r.json();
    if (!j.sections) return;
    sec.forEach((s) => {
      const html = j.sections[s.section || s.id];
      if (!html) return;
      const target = el === drawer ? (s.selector ? document.querySelector(s.selector) : document.getElementById(s.id)) : (document.getElementById(s.id) && (document.getElementById(s.id).querySelector(s.selector) || document.getElementById(s.id)));
      if (target) target.innerHTML = el.getSectionInnerHTML(html, el === drawer ? s.selector : s.selector);
    });
    const tukss = j.item_count === 0;
    if (el === drawer) { drawer.classList.toggle('is-empty', tukss); if (drawer.close) { const ov = drawer.querySelector('#CartDrawer-Overlay'); if (ov) ov.addEventListener('click', drawer.close.bind(drawer)); } }
    else { el.classList.toggle('is-empty', tukss); const ft = document.getElementById('main-cart-footer'); if (ft) ft.classList.toggle('is-empty', tukss); }
    const n2 = document.getElementById('CartDrawer-Note'); if (n2 && noteVal && n2.value !== noteVal) n2.value = noteVal;
    if (el === drawer && bija && drawer.classList.contains('active') && typeof trapFocus === 'function') trapFocus(document.getElementById('CartDrawer'), drawer.querySelector('.drawer__inner'));
  };

  const labot = () => {
    if (darbs) { velreiz = true; return darbs; }
    let k0 = kustiba;
    darbs = (async () => {
      try {
        for (let i = 0; i < 80 && !etaCfg(); i++) { if (window.isEstimatorLoaded !== true && i > 30) return false; await wait(100); }
        const cfg = etaCfg();
        if (!cfg) return false;
        const labels = new Set(Object.values(cfg.rules || {}).map((r) => etaText(cfg, 'cartLabel', r.languages)).filter(Boolean));
        k0 = kustiba;
        const cart = await (await f0(`${root}cart.js`, { cache: 'no-store' })).json();
        const todo = (cart.items || []).filter((it) => !izlaist.has(it.key) && !Object.keys(it.properties || {}).some((k) => labels.has(k)));
        let mainits = false;
        await Promise.all(todo.map((it) => produkts(it.handle)));
        for (const it of todo) {
          let props = null;
          try {
            const p = await produkts(it.handle);
            const v = p && p.variants.find((x) => x.id === it.variant_id);
            if (v) props = etaProps({ id: p.id, vendor: p.vendor, type: p.type, tags: p.tags }, { id: v.id, sku: v.sku || '', quantity: v.available ? 1 : 0, policy: v.available ? 'deny' : 'continue', tracked: v.inventory_management });
          } catch (e) { props = null; }
          if (!props) { izlaist.add(it.key); continue; }
          for (let i = 0; svesi > 0 && i < 60; i++) await wait(50);
          const svaigs = await (await f0(`${root}cart.js`, { cache: 'no-store' })).json();
          const rinda = (svaigs.items || []).find((x) => x.key === it.key);
          if (!rinda || Object.keys(rinda.properties || {}).some((k) => labels.has(k))) continue;
          const r = await f0(`${root}cart/change.js`, { method: 'POST', headers: JSONH, body: JSON.stringify({ id: rinda.key, quantity: rinda.quantity, properties: Object.assign({}, rinda.properties || {}, props) }) });
          if (r.ok) mainits = true; else izlaist.add(it.key);
        }
        if (mainits) await parzimet();
        return mainits;
      } catch (e) { return false; } finally { darbs = null; const kust = kustiba !== k0; if (velreiz || (kust && atk < 3)) { atk = velreiz ? 0 : atk + 1; velreiz = false; setTimeout(labot, 150); } else atk = 0; }
    })();
    return darbs;
  };

  // pēc jebkuras pievienošanas grozam (tēma, komplekti, "pērc kopā" lietotnes)
  const pecPievienosanas = (url) => { kustiba++; if (url.indexOf('/cart/add') !== -1) setTimeout(labot, 150); };
  const f0 = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    const lido = typeof url === 'string' && MUT.test(url);
    if (lido) svesi++;
    let p;
    try { p = f0.apply(this, arguments); } catch (e) { if (lido) svesi--; throw e; }
    p.then(() => { if (lido) { svesi--; pecPievienosanas(url); } }, () => { if (lido) svesi--; });
    return p;
  };
  const o0 = XMLHttpRequest.prototype.open, s0 = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__pdUrl = typeof url === 'string' && MUT.test(url) ? url : ''; return o0.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    const url = this.__pdUrl;
    if (url) { svesi++; this.addEventListener('loadend', () => { svesi--; pecPievienosanas(url); }, { once: true }); }
    try { return s0.apply(this, arguments); } catch (e) { if (url) svesi--; throw e; }
  };

  const start = () => { f0(`${root}cart.js`, { cache: 'no-store' }).then((r) => r.json()).then((c) => { if (c.item_count > 0) labot(); }).catch(() => {}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.ergoPiegade = { cfg: etaCfg, props: etaProps, labot };
})();
